import { RootState } from 'redux-store/store'

export const getCurrentPayment = (state: RootState) =>
  state.payments.currentPayment
